import React, { useEffect, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import Loader from 'rsuite/Loader';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';

import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import ScrollToHash from './components/ScrollToHash';
import Layout from './components/Layout';

const Home = React.lazy(() => import('./pages/Home'));
const Contact = React.lazy(() => import('./pages/Contact'));

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out-cubic',
    });
  }, []);

  useDocTitle("Niwy Natury - Pracownia Zdrowia.");

  return (
    <>
      <Router>
        <ScrollToTop>
          <ScrollToHash />
          <Layout>
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/kontakt" element={<Contact />} />
              </Routes>
            </Suspense>
          </Layout>
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
